import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { inr } from "@/lib/format";
import { Kpi, PageHeader, Section } from "@/components/common/kit";
import RemoteTable from "@/components/common/RemoteTable";
import { DateRangeFilter, SalesmanSelect, useRange } from "@/components/common/Filters";

export const EXP_COLS = [
  { key: "expense_no", label: "ID" }, { key: "date", label: "Date", type: "date" }, { key: "salesman_name", label: "Salesman" },
  { key: "category", label: "Category" }, { key: "amount", label: "Amount", type: "money" }, { key: "paid_to", label: "Paid To" },
  { key: "description", label: "Note" }, { key: "created_by", label: "Entered by" },
];

export default function Expenses() {
  const { settings } = useAuth();
  const [range, setRange] = useRange("today");
  const [sid, setSid] = useState("");
  const [cat, setCat] = useState("all");
  const [sum, setSum] = useState(0);
  return (
    <div className="space-y-6">
      <PageHeader title="Expenses" subtitle="Daily salesman expenses — deducted in cash reconciliation" />
      <div className="flex flex-wrap gap-2">
        <DateRangeFilter value={range} onChange={setRange} />
        <SalesmanSelect value={sid} onChange={setSid} allowAll />
        <Select value={cat} onValueChange={setCat}>
          <SelectTrigger className="h-9 w-44" data-testid="expense-category-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="all">All categories</SelectItem>{settings?.expense_categories.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="grid gap-3 sm:grid-cols-3"><Kpi label="Total for filter" value={inr(sum)} tone="amber" testid="expenses-sum" /></div>
      <Section>
        <RemoteTable url="/expenses" params={{ salesman_id: sid || undefined, category: cat === "all" ? undefined : cat, date_from: range.from, date_to: range.to }}
          columns={EXP_COLS} onData={(d) => setSum(d.sum)} title="Expenses" exportable testid="expenses-table" />
      </Section>
    </div>
  );
}
